export default "__VITE_PUBLIC_ASSET__423fd041__"